<template>
  <div>
    <poll-replies
      :title="title"
      :descriptionHtml="''"
      :pollId="pollId"
    ></poll-replies>
  </div>
</template>

<script>
import pollReplies from "../polls/components/poll_replies.vue";
import adminApi from "@/api/admin";
import { ref } from "@vue/composition-api";

export default {
  components: {
    pollReplies,
  },
  props: ["newsId", "pollId"],
  setup(props) {
    const title = ref("");

    const getNewsTitle = async () => {
      const newsResponse = await adminApi.getNews(props.newsId);
      if (newsResponse.ok) {
        title.value = newsResponse.data.title;
      }
    };

    getNewsTitle();

    return {
      title,
    };
  },
};
</script>

<style>
</style>